export enum ApiFilePathTypes {
  applicant = "applicant",
  candidate = "candidate",
  cv = "cv",
  employee = "employee",
  employee_avatar = "employee_avatar",
  documents = "documents",
  organization_documents = "organization_documents",
  applicant_photo = "applicant_photo",
  background = "background",
  organization = "organization",
  team = "team",
  blog_post = "blog_post",
  blog_attachment = "blog_attachment",
  department = "department",
  career_site = "career_site",
  task = "task",
  recognition_badge = "recognition_badge",

  data_import = "data_import",

  ai_assistant = "ai_assistant",

  // НЕ НАДО ИСПОЛЬЗОВАТЬ - устаревшие типы файлов
  other = "other",
}

export interface ApiFileLink {
  download_url: string;
}
